"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const useForm_1 = __importDefault(require("../../../../app/shared/utils/useForm"));
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
const DistributorField_vue_1 = __importDefault(require("../../../molecules/DistributorField.vue"));
const EngancheField_vue_1 = __importDefault(require("../../../molecules/EngancheField.vue"));
const leading_step_vue_1 = __importDefault(require("../atoms/leading-step.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'step-one',
    emits: ["onValidate"],
    setup(__props, { emit }) {
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const range = (0, vue_2.ref)({
            min: 0,
            max: 80
        });
        const form = (0, useForm_1.default)({
            distributor: null,
            enganche: { percentage: 0, total: 0 },
            plazo: 12
        });
        const handleValidation = async () => {
            await store.setStep(1);
            store.$patch({
                activeCard: "",
                abc: null
            });
            form.resetErrors();
            let errorsCount = 0;
            if (!Boolean(form.distributor)) {
                form.errors.distributor = "Debes escoger un distribuidor";
                errorsCount += 1;
            }
            if (form.enganche.percentage < 0) {
                form.errors.enganche = "El enganche no puede ser menor del $0.00";
                errorsCount += 1;
            }
            if (form.plazo <= 0) {
                form.errors.plazo = "Debes escoger un plazo";
                errorsCount += 1;
            }
            if (errorsCount > 0) {
                return;
            }
            store.$patch({
                distributor: form.distributor,
                enganchePercentage: form.enganche.percentage,
                enganche: form.enganche.total,
                plazo: form.plazo
            });
            store.state.id = Number(form.distributor?.state?.id);
            store.state.name = form.distributor?.state?.name;
            window.dataLayer.push({
                event: "calcular_financiamiento",
                modelo: store.powerTrain?.trim?.model?.name,
                version: store.powerTrain?.name,
                year_model: store.powerTrain?.trim?.model?.year,
                distribuidor: form.distributor?.name,
                estado: form.distributor?.state?.name,
                enganche: form.enganche.total,
                plazo: form.plazo + " meses"
            });
            await store.setStep(2);
            emit("onValidate");
        };
        return { __sfc: true, emit, store, range, form, handleValidation, DistributorField: DistributorField_vue_1.default, EngancheField: EngancheField_vue_1.default, LeadingStep: leading_step_vue_1.default };
    }
});
